import React, { useEffect } from 'react';
import { Button, Form, Grid, Icon, Menu, Segment } from 'semantic-ui-react';
import { TextField } from '../../common/FormFields';
import { connect } from 'react-redux';
import * as actions from '../../../redux/actions';
import * as selectors from '../../../redux/selectors';
import { bindActionCreators } from 'redux';
import { Formik } from 'formik';
import { listingInitialValues, listingValidationSchema } from '../adslot.constants';
import FirmDropDown from '../FirmDropDown';
import CloudinaryUploadWidget from '../CloudinaryUploadWidget';
import PageContainer from '../../common/PageContainer';

const AddListingPage = ({ preloadShowcaseData, addListing, firm, reps }) => {
  useEffect(() => preloadShowcaseData(), []);

  const handleSubmit = (listing, formik) => {
    addListing(listing);

    formik.resetForm();
  };

  return (
    <PageContainer>
      <Menu borderless>
        <Menu.Item header>
          <Icon name="star outline" />
          Create Listing
        </Menu.Item>
      </Menu>

      <Formik
        initialValues={{ ...listingInitialValues, showcaseFirmId: firm.id }}
        enableReinitialize
        validationSchema={listingValidationSchema}
        onSubmit={handleSubmit}
      >
        {formik => (
          <Form onSubmit={formik.handleSubmit} widths="equal">
            <Form.Group>
              <FirmDropDown
                name="showcaseFirmId"
                label="Firm"
                formik={formik}
                value={formik.values.showcaseFirmId}
                onChange={formik.handleChange}
                error={formik.touched.showcaseFirmId && Boolean(formik.errors.showcaseFirmId)}
                errorMessage={formik.errors.showcaseFirmId}
              />
            </Form.Group>

            <Segment>
              <Form.Group>
                <TextField
                  name="description1"
                  formik={formik}
                  value={formik.values.description1}
                  onChange={formik.handleChange}
                  error={formik.touched.description1 && Boolean(formik.errors.description1)}
                  errorMessage={formik.errors.description1}
                  label="Description 1"
                />
              </Form.Group>

              <Form.Group>
                <TextField
                  name="description2"
                  formik={formik}
                  value={formik.values.description2}
                  onChange={formik.handleChange}
                  error={formik.touched.description2 && Boolean(formik.errors.description2)}
                  errorMessage={formik.errors.description2}
                  label="Description 2"
                />
              </Form.Group>

              <Form.Group>
                <TextField
                  name="line1"
                  formik={formik}
                  value={formik.values.line1}
                  onChange={formik.handleChange}
                  error={formik.touched.line1 && Boolean(formik.errors.line1)}
                  errorMessage={formik.errors.line1}
                  label="Line 1"
                />
              </Form.Group>

              <Form.Group>
                <TextField
                  name="line2"
                  formik={formik}
                  value={formik.values.line2}
                  onChange={formik.handleChange}
                  error={formik.touched.line2 && Boolean(formik.errors.line2)}
                  errorMessage={formik.errors.line2}
                  label="Line 2"
                />
              </Form.Group>

              <Form.Group>
                <TextField
                  name="line3"
                  formik={formik}
                  value={formik.values.line3}
                  onChange={formik.handleChange}
                  error={formik.touched.line3 && Boolean(formik.errors.line3)}
                  errorMessage={formik.errors.line3}
                  label="Line 3"
                />
              </Form.Group>

              <Grid columns="2">
                <Grid.Column>
                  <TextField
                    name="imageUrl"
                    formik={formik}
                    value={formik.values.imageUrl}
                    onChange={formik.handleChange}
                    error={formik.touched.imageUrl && Boolean(formik.errors.imageUrl)}
                    errorMessage={formik.errors.imageUrl}
                    label="Image URL"
                  />
                </Grid.Column>
                <Grid.Column style={{ paddingTop: 37 }}>
                  <CloudinaryUploadWidget formik={formik} fieldName={'imageUrl'} />
                </Grid.Column>
              </Grid>

              <TextField
                name="price"
                formik={formik}
                value={formik.values.price}
                onChange={formik.handleChange}
                error={formik.touched.price && Boolean(formik.errors.price)}
                errorMessage={formik.errors.price}
                label="Price"
              />
            </Segment>

            <Segment>
              <Form.Group>
                <TextField
                  name="address"
                  formik={formik}
                  value={formik.values.address}
                  onChange={formik.handleChange}
                  error={formik.touched.address && Boolean(formik.errors.address)}
                  errorMessage={formik.errors.address}
                  label="Address"
                />
                <TextField
                  name="city"
                  formik={formik}
                  value={formik.values.city}
                  onChange={formik.handleChange}
                  error={formik.touched.city && Boolean(formik.errors.city)}
                  errorMessage={formik.errors.city}
                  label="City"
                />
              </Form.Group>

              <Form.Group>
                <TextField
                  name="state"
                  formik={formik}
                  value={formik.values.state}
                  onChange={formik.handleChange}
                  error={formik.touched.state && Boolean(formik.errors.state)}
                  errorMessage={formik.errors.state}
                  label="State"
                />
                <TextField
                  name="zip"
                  formik={formik}
                  value={formik.values.zip}
                  onChange={formik.handleChange}
                  error={formik.touched.zip && Boolean(formik.errors.zip)}
                  errorMessage={formik.errors.zip}
                  label="Zip"
                />
              </Form.Group>
            </Segment>

            <Button color="black">Cancel</Button>
            <Button content="Save" labelPosition="left" icon="save" onClick={formik.handleSubmit} positive />
          </Form>
        )}
      </Formik>
    </PageContainer>
  );
};

const mapStateToProps = state => ({
  firm: selectors.getCurrentFirm(state),
  reps: selectors.getRepOptionsForFirm(state),
});

const mapDispatchToProps = dispatch => ({
  preloadShowcaseData: bindActionCreators(actions.showcase.preloadShowcaseData, dispatch),
  addListing: bindActionCreators(actions.listing.addListing, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddListingPage);
